import React, { useState } from 'react';
import { PlusIcon, CalendarIcon, ClipboardDocumentCheckIcon } from '@heroicons/react/24/outline';

const InventoryManagement = () => {
  const [inventories] = useState([
    { id: 1, name: 'Inventaire Annuel', date: '2023-12-15', status: 'Planifié', responsable: 'Marie Dupont' },
    { id: 2, name: 'Inventaire Trimestriel', date: '2023-08-30', status: 'Terminé', responsable: 'Paul Martin' },
    { id: 3, name: 'Inventaire Flash', date: '2023-07-10', status: 'Terminé', responsable: 'Sophie Bernard' },
  ]);

  const [movements] = useState([
    { id: 1, date: '2023-08-30', product: 'Planche Wind 140L', type: 'Ajustement', quantity: -2, reason: 'Inventaire' },
    { id: 2, date: '2023-08-30', product: 'Voile 6m²', type: 'Ajustement', quantity: 1, reason: 'Inventaire' },
    { id: 3, date: '2023-07-10', product: 'Combinaison S', type: 'Ajustement', quantity: -1, reason: 'Dommage' },
  ]);

  return (
    <div className="space-y-8">
      {/* Section Inventaires */}
      <div>
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-medium text-gray-900">Inventaires</h3>
          <button
            type="button"
            className="inline-flex items-center px-3 py-1.5 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
          >
            <PlusIcon className="-ml-1 mr-1 h-4 w-4" aria-hidden="true" />
            Planifier un inventaire
          </button>
        </div>
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Nom
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Date
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Statut
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Responsable
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {inventories.map((inventory) => (
                <tr key={inventory.id}>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{inventory.name}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{inventory.date}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full 
                      ${inventory.status === 'Terminé' ? 'bg-green-100 text-green-800' :
                      inventory.status === 'En cours' ? 'bg-blue-100 text-blue-800' : 
                      'bg-yellow-100 text-yellow-800'}`}>
                      {inventory.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{inventory.responsable}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 space-x-2">
                    {inventory.status === 'Planifié' && (
                      <button className="text-blue-600 hover:text-blue-900 inline-flex items-center">
                        <CalendarIcon className="mr-1 h-4 w-4" />
                        Démarrer
                      </button>
                    )}
                    {inventory.status === 'En cours' && (
                      <button className="text-green-600 hover:text-green-900 inline-flex items-center">
                        <ClipboardDocumentCheckIcon className="mr-1 h-4 w-4" />
                        Terminer
                      </button>
                    )}
                    {inventory.status === 'Terminé' && (
                      <button className="text-primary-600 hover:text-primary-900">
                        Voir rapport
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Section Mouvements d'Inventaire */}
      <div>
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-medium text-gray-900">Mouvements d'Inventaire</h3>
        </div>
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Date
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Produit
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Type
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Quantité
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Raison
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {movements.map((movement) => (
                <tr key={movement.id}>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{movement.date}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{movement.product}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{movement.type}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    <span className={movement.quantity > 0 ? 'text-green-600' : 'text-red-600'}>
                      {movement.quantity > 0 ? `+${movement.quantity}` : movement.quantity}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{movement.reason}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default InventoryManagement; 